import React, { Component } from "react";
import F from "./Functions";
// import { Redirect, Link } from "react-router-dom";
// import { Layout, Icon, Tooltip, Row, Col, Button, Divider, Input } from "antd";
// import "./layout.css";
// import DashMenu from "./Menu";
// import { Provider, Translate, Translator } from "react-translated";
// import translation from "./lang/translation";
// import Notificationbell from "./components/notificationbell";
// import F from "./Functions";

class Collapse extends Component {
  //   state = { childHeight: 0 };

  //   componentDidMount() {
  //     F.log("Client Height 1 =>", this.content.clientHeight);
  //     const childHeightRaw = this.content.clientHeight;
  //     const childHeight = `${childHeightRaw / 16}rem`;

  //     this.setState({ childHeight });
  //   }

  // componentDidMount() {
  //   F.log("Client Height 1 =>", this.content.clientHeight);
  // }
  // componentDidUpdate() {
  //   F.log("Client Height 2 =>", this.content.clientHeight);
  // }

  render() {
    const { children, expandStats } = this.props;
    // const { childHeight } = this.state;

    // F.log("Client Height 1 =>", this.content.clientHeight);
    // return (
    //   <div
    //     className="collapse"
    //     style={{
    //       maxHeight: expandStats ? this.content.clientHeight : 0,
    //     }}
    //   >
    //     <div ref={(content) => (this.content = content)}>{children}</div>
    //   </div>
    // );
    return expandStats ? <div>{children}</div> : null;
  }
}

Collapse.defaultProps = {
  expandStats: false,
};

export default Collapse;



// WEBPACK FOOTER //
// ./src/Collapse.js